import { useEffect, useState } from "react";
import { Box, Typography, Backdrop, Fade, CircularProgress } from "@mui/material";
import { keyframes } from "@mui/system";
import { useTranslation } from "react-i18next";
import { Z_INDEX } from "../styles/zIndex";

const tvOff = keyframes`
  0% { transform: scale(1); opacity: 1; }
  70% { transform: scaleY(0.05); opacity: 1; }
  100% { transform: scale(0); opacity: 0; }
`;

interface Props {
  onFinish?: () => void;
  pos: any;
}

const ShutdownScreen = ({ onFinish, pos }: Props) => {
  const { t } = useTranslation();
  const [progress, setProgress] = useState(0);
  const [show, setShow] = useState(true);
  const [powerOff, setPowerOff] = useState(false);

  const duration = Math.floor(Math.random() * 500) + 1000;

  useEffect(() => {
    const interval = 100;
    const increment = 100 / (duration / interval);

    const timer = setInterval(() => {
      setProgress((prev) => {
        const next = prev + increment;
        if (next >= 100) {
          clearInterval(timer);
          setProgress(100);
          setTimeout(() => setPowerOff(true), 500);
          setTimeout(() => {
            setShow(false);
            onFinish?.();
          }, 1500);
        }
        return next >= 100 ? 100 : next;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [duration, onFinish]);

  return (
    <Fade in={show} timeout={500}>
      <Backdrop
        open={show}
        sx={{
          color: '#f5f5f5',
          zIndex: Z_INDEX.shutdown,
          flexDirection: "column",
          backgroundColor: '#1a1a2e',
        }}
      >
        <Box
          sx={{
            animation: powerOff ? `${tvOff} 1s ease forwards` : "none",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            p: 3,
            transition: "all 0.6s ease",
          }}
        >
          {!powerOff && (
            <>
              <Typography
                variant="h5"
                sx={{ mb: 2, color: '#f5f5f5', fontWeight: 600 }}
              >
                {t("common:status.disconnectingDepot", { depot: pos.DepotName })}
              </Typography>

              <Box
                sx={{
                  position: "relative",
                  display: "inline-flex",
                  mb: 1,
                }}
              >
                <CircularProgress
                  variant="determinate"
                  value={progress}
                  color="info"
                  size={100}
                  thickness={4.5}
                />
                <Box
                  sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="h6" sx={{ color: '#f5f5f5' }}>
                    {Math.round(progress)}%
                  </Typography>
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Backdrop>
    </Fade>
  );
};

export default ShutdownScreen;
